import { taxonomyLookupModalReducerKey } from './TaxonomyLookupModalConstants';

export const taxonomyLookupModal = (state) => {
  return state.get(taxonomyLookupModalReducerKey);
};

export const isLoading = (state) => {
  return taxonomyLookupModal(state).get('isLoading');
};
export const opModel = (state) => {
  return taxonomyLookupModal(state).get('opModel');
};

export const suggestConfig = (state) => {
  return taxonomyLookupModal(state).get('suggestConfig');
};

export const boundOperator = (state) => {
  return taxonomyLookupModal(state).get('boundOperator');
};

export const search = (state) => {
  return taxonomyLookupModal(state).get('search');
};

export const selectedItems = (state) => {
  return taxonomyLookupModal(state).get('selectedItems');
};

export const totalHitCount = (state) => {
  return taxonomyLookupModal(state).get('totalHitCount');
};

export const transferEnabled = (state) => {
  return taxonomyLookupModal(state).get('transferEnabled');
};
